import { Environment } from '../app/types/environment';

export const environment: Environment = {
  production: import.meta.env.NG_APP_PRODUCTION,
  apiUrl: import.meta.env.NG_APP_API_URL,
  websocketUrl: import.meta.env.NG_APP_WEBSOCKET_URL,
  googleMapId: import.meta.env.NG_APP_GOOGLE_MAP_ID,
  googleOAuthClientId: import.meta.env.NG_APP_GOOGLE_OAUTH_CLIENT_ID,
  googleOAuthIssuer: import.meta.env.NG_APP_GOOGLE_OAUTH_ISSUER,
  googleOAuthJwksUrl: import.meta.env.NG_APP_GOOGLE_OAUTH_JWKS_URL,
  googleOAuthLoginUrl: import.meta.env.NG_APP_GOOGLE_OAUTH_LOGIN_URL,
  googleOAuthTokenEndpoint: import.meta.env.NG_APP_GOOGLE_OAUTH_TOKEN_ENDPOINT,
  googleOAuthUserinfoEndpoint: import.meta.env
    .NG_APP_GOOGLE_OAUTH_USER_INFO_ENDPOINT,
};
